<ng-container *ngIf="!showExternal">
    <input [textMask]="{mask: dateMask, guide: true, showMask: true}" [(ngModel)]="myModel"
        placeholder="{{placeholder}}" (blur)="changeInput($event)" (keydown)="keyDown($event)" (keyup)="keyUp($event)"
        [disabled]="disabled" value="" class="form-control border-input" />
</ng-container>
<ng-container *ngIf="showExternal && !isFormControl">
    <mat-form-field class="input-external" appearance="{{isShowOutline ? 'outline' : ''}}">
        <input matInput inputmode="numeric" [textMask]="{mask: dateMask, guide: true, showMask: true}"
            [(ngModel)]="myModel" placeholder="{{placeholder}}" (blur)="changeInput($event)" (keydown)="keyDown($event)"
            (keyup)="keyUp($event)" [disabled]="disabled" value="" />
    </mat-form-field>
</ng-container>
<ng-container *ngIf="showExternal && isFormControl">
    <mat-form-field class="input-external" appearance="{{isShowOutline ? 'outline' : ''}}">
        <input matInput inputmode="numeric" [textMask]="{mask: dateMask, guide: true, showMask: true}"
            [(ngModel)]="myModel" [id]="inpControlName" #calendarCtrl="ngModel" [name]="inpControlName"
            placeholder="{{placeholder}}" (blur)="changeInput($event)" (keydown)="keyDown($event)"
            (keyup)="keyUp($event)" (focusin)="focusin($event)" (focusout)="focusout($event)"
            [disabled]="disabled" value="" />
        <mat-error *ngIf="calendarCtrl.errors">
            <div>{{ errorMessage }}</div>
        </mat-error>
    </mat-form-field>
</ng-container>
